// extracted by mini-css-extract-plugin
module.exports = {"Section":"Auth_Section__G_Mdu","Header":"Auth_Header__1VwbD","InnerSection":"Auth_InnerSection__1BWyL"};